function setting(vm) {
	return vm.$resource('setting{/id}');
}

export default setting;



// WEBPACK FOOTER //
// ./src/resource/setting.js